import { render, staticRenderFns } from "./appealModal.vue?vue&type=template&id=dc72dca8&scoped=true"
import script from "./appealModal.vue?vue&type=script&lang=js"
export * from "./appealModal.vue?vue&type=script&lang=js"
import style0 from "./appealModal.vue?vue&type=style&index=0&id=dc72dca8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc72dca8",
  null
  
)

export default component.exports